document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('site-header');
    const container = header?.querySelector('.header-container');

    if (!header || !container) return;

    const activationDelta = parseInt(header.dataset.fixedActivation, 10) || 100;
    const exitHoldDelta = 100;

    let ticking = false;
    let lastY = window.scrollY;
    let prevY = lastY;
    let headerBottom = 0;
    let headerHeight = 0;
    let spacer = null;

    const overlayActive = () => header.classList.contains('header-overlay');

    function elemHeight(el) {
        if (!el) return 0;
        return Math.max(0, Math.round(el.getBoundingClientRect().height || 0));
    }

    function ensureSpacer() {
        if (overlayActive()) return;
        if (!spacer) {
            spacer = document.createElement('div');
            spacer.className = 'site-header-spacer';
            spacer.setAttribute('aria-hidden', 'true');
            header.insertAdjacentElement('afterend', spacer);
        }
    }

    function setSpacer(on) {
        if (overlayActive()) return;
        ensureSpacer();
        spacer.style.height = on ? `${headerHeight}px` : '';
    }

    function measure() {
        headerHeight = elemHeight(container);
        headerBottom = (header.getBoundingClientRect().top + window.scrollY) + headerHeight;
        ensureSpacer();
    }

    function teardown() {
        header.classList.remove('header-offscreen', 'fixed', 'exiting');
        setSpacer(false);
    }

    function update() {
        ticking = false;
        const y = lastY || 0;
        const distancePast = y - headerBottom;
        const fixedRemovalThreshold = Math.max(0, activationDelta - exitHoldDelta);
        const scrollingUp = y < prevY;

        if (distancePast >= 0) {
            if (!header.classList.contains('header-offscreen')) {
                measure();
                setSpacer(true);
                header.classList.add('header-offscreen');
                header.classList.remove('exiting');
            }
            if (distancePast >= activationDelta) {
                header.classList.add('fixed');
                header.classList.remove('exiting');
            } else if (scrollingUp) {
                header.classList.add('exiting');
                header.classList.toggle('fixed', distancePast >= fixedRemovalThreshold);
            } else {
                header.classList.remove('fixed', 'exiting');
            }
        } else {
            teardown();
        }

        prevY = y;
    }

    function onScroll() {
        lastY = window.scrollY;
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }

    measure();
    update();

    window.addEventListener('scroll', onScroll, { passive: true });

    let resizeTimer;
    const onResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => { measure(); update(); }, 100);
    };

    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    window.addEventListener('header:remeasure', () => { measure(); update(); });

    const onFocusEnter = () => {
        if (header.classList.contains('header-offscreen') && !header.classList.contains('fixed')) {
            header.classList.add('fixed');
        }
    };

    container.addEventListener('focusin', onFocusEnter);
    container.addEventListener('mouseenter', onFocusEnter);
});
